(() => {

	'use strict';


	/* =========================================================
	   Elements
	   ========================================================= */

	const heroVideo = document.getElementById('cacHeroVideo');
	const video = document.getElementById('cacVideo');

	const playOverlay = heroVideo?.querySelector(
		'.cac-hero-video__overlay'
	);

	const controlsToggle = heroVideo?.querySelector(
		'.cac-hero-video__controls-toggle'
	);


	/* ---------------------------------------------------------
	   If any required element is missing, quietly stop.

	   This keeps the script safe if the component is removed from
	   a page later but the JS bundle still contains this code.
	   --------------------------------------------------------- */

	if (
		!heroVideo ||
		!video ||
		!playOverlay ||
		!controlsToggle
	) {
		return;
	}


	/* =========================================================
	   Input capability

	   Instead of guessing from screen width, ask whether the
	   primary input device behaves like a mouse/trackpad.

	   Desktop / normal laptop:
	   hover:hover + pointer:fine

	   Typical touchscreen:
	   hover:none + pointer:coarse
	   ========================================================= */

	const desktopPointer = window.matchMedia(
		'(hover: hover) and (pointer: fine)'
	);


	/* =========================================================
	   Video capability check

	   If HTML5 video or MP4 playback isn't available, do nothing.

	   The fallback <img> inside <video> remains visible and no
	   fake interactive overlay appears.
	   ========================================================= */

	const canPlayMp4 =
		typeof video.canPlayType === 'function' &&
		video.canPlayType('video/mp4') !== '';


	if (!canPlayMp4) {
		return;
	}


	/* We now know the component can behave like a video player. */

	heroVideo.classList.add('is-video-ready');


	/* =========================================================
	   Start playback
	   ========================================================= */

	const playVideo = () => {

		/*
			Touch-oriented devices receive native controls once
			playback begins.

			Mouse/trackpad devices remain visually clean and get
			our small "Controls" enhancement instead.
		*/

		if (!desktopPointer.matches) {
			video.controls = true;
		}


		/*
			Because this function is called directly in response
			to a genuine user click, playback is allowed to begin
			with audio.

			We deliberately never set video.muted = true.
		*/

		const playPromise = video.play();


		/*
			play() returns a Promise in modern browsers.

			Only update the visual state after playback really
			starts successfully.
		*/

		if (playPromise !== undefined) {

			playPromise
				.then(() => {

					heroVideo.classList.add('is-playing');

					/*
						Desktop gets our optional controls button
						because native controls begin hidden.
					*/

					if (
						desktopPointer.matches &&
						!video.controls
					) {
						heroVideo.classList.add(
							'show-controls-toggle'
						);
					}

				})
				.catch(() => {

					/*
						If the browser unexpectedly rejects play,
						leave everything in the poster state.
					*/

					heroVideo.classList.remove('is-playing');
					heroVideo.classList.remove(
						'show-controls-toggle'
					);

				});
		}

	};


	/* =========================================================
	   Initial poster click

	   The overlay covers the whole poster, so clicking anywhere
	   on it initiates playback.
	   ========================================================= */

	playOverlay.addEventListener('click', playVideo);


	/* =========================================================
	   Click video to pause / resume

	   This works only after playback has started because before
	   that the play overlay is sitting over the video.
	   ========================================================= */

	video.addEventListener('click', () => {

		if (!heroVideo.classList.contains('is-playing')) {
			return;
		}


		if (video.paused) {

			video.play();

		}
		else {

			video.pause();

		}

	});


	/* =========================================================
	   Controls button

	   Once the visitor asks for native controls, we leave them
	   enabled for the remainder of this playback.

	   The little custom Controls button then disappears.
	   ========================================================= */

	controlsToggle.addEventListener('click', (event) => {

		/*
			Prevent this click from being interpreted as another
			click on the surrounding video area.
		*/

		event.stopPropagation();


		video.controls = true;


		heroVideo.classList.remove(
			'show-controls-toggle'
		);

	});


	/* =========================================================
	   Reset when playback ends
	   ========================================================= */

	video.addEventListener('ended', () => {

		/*
			load() resets the media element and restores the
			poster frame rather than leaving the final video
			frame sitting on screen.
		*/

		video.load();


		/*
			Reset native controls.

			On the next playback:
			- desktop starts clean again
			- touch devices receive controls again in playVideo()
		*/

		video.controls = false;


		heroVideo.classList.remove(
			'is-playing',
			'show-controls-toggle'
		);

	});


	/* =========================================================
	   Optional safety reset if the source is reloaded manually
	   elsewhere in your code.
	   ========================================================= */

	video.addEventListener('emptied', () => {

		heroVideo.classList.remove(
			'is-playing',
			'show-controls-toggle'
		);

	});

})();